var t;!function(t){t.RIGHT="right",t.RIGHT_START="right-start",t.RIGHT_END="right-end",t.LEFT="left",t.LEFT_START="left-start",t.LEFT_END="left-end"}(t||(t={}));export{t as Placement};
